/* week-header.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./week-header.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { memo } from 'react';
import { Box, Text } from '@atlaskit/primitives/compiled';
import WeekDayGrid from './week-day-grid';
var styles = {
  columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
var WeekHeader = /*#__PURE__*/memo(function WeekHeader(_ref) {
  var daysShort = _ref.daysShort,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(WeekDayGrid, {
    isHidden: true,
    testId: testId && "".concat(testId, "--column-headers")
  }, daysShort.map(function (shortDay) {
    return /*#__PURE__*/React.createElement(Box, {
      padding: "space.100",
      xcss: styles.columnHeader,
      key: shortDay,
      role: "columnheader",
      testId: testId && "".concat(testId, "--column-header")
    }, /*#__PURE__*/React.createElement(Text, {
      weight: "bold",
      size: "UNSAFE_small",
      align: "center",
      color: "color.text.subtle"
    }, shortDay));
  }));
});
WeekHeader.displayName = 'WeekHeader';

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default WeekHeader;